module.exports = __webpack_public_path__ + "static/icelandic-lamb-4c1fc2537deb01fb30efc7b975b338a9.png";